import { render, staticRenderFns } from "./usaReviewEdit.vue?vue&type=template&id=946501a6&"
import script from "./usaReviewEdit.vue?vue&type=script&lang=js&"
export * from "./usaReviewEdit.vue?vue&type=script&lang=js&"
import style0 from "./usaReviewEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports